import Form from "/src/components/form/Form";
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import FormCompany from "../modal/FormCompany";
import './ChooseCompany.css';
import ListCompany from "./ListCompany/ListCompany";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import hasPermission from "/src/utils/hasPermission";
import { useState } from "react";
import InputSearch from "/src/components/UI/InputSearch/InputSearch";

function ChooseCompany() {

    const form = { id: null, name: null, image: null, owner: null }
    const [companies, setCompanies] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const onCreateCompany = (data) => {
        ScrollIntoSlide('list-company');
        setTimeout(() => setCompanies([data, ...companies]), 350)
    }

    const handleSearch = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
    };


    const getFilteredCompanies = () => {
        if (searchTerm.length >= 3) {
            return companies.filter(company =>
                company.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        return companies;
    };

    const filteredCompanies = getFilteredCompanies();


    return (
        <div className="choose-company-part">
            <Slider>
                <Slide name='list-company'>
                    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                        <h2> Choose an Organization </h2>
                        {hasPermission('create_organization') ? <IconButton className="main-iconButton profil_action main_add-button" icon="fas fa-plus" onClick={() => ScrollIntoSlide('create-company')}  /> : null }
                    </div>
                    <div className="start-row">
                        <div className="input-container no-margin" style={{ justifyContent: 'center' }}>
                            <InputSearch style={{ marginRight : 20, background:'var(--white)'}}  placeholderLibelle="organization" name="organization"  onChange={handleSearch} />
                        </div>
                    </div>
                    <ListCompany state={[filteredCompanies, setCompanies]} />
                </Slide>
                <Slide name='create-company' className='create-company'>
                    <div style={{ display: 'flex', alignItems: 'baseline', marginLeft: '10px' }}>
                        <IconButton className="main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-arrow-left" onClick={() => ScrollIntoSlide('list-company')} />
                        <h2 style={{ marginLeft: '55px' }}> Add an Organization </h2>

                    </div>
                    <FormCompany form={form} onSend={onCreateCompany} />
                </Slide>
            </Slider>
        </div>
    );
}

export default ChooseCompany;